import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { useSelector } from "react-redux";
import FileUploader from "../../../reusableComponents/FileUploader2";
import KmlFileUploader from "../../../../TCPForms/reusableComponents/KmlFileUploader";
import LowRiskDisclaimer from "../../../../../../components/LandUseNOC/LowRiskDisclaimer";
import MapSiteInspection from "../../../../../employee/ScheduleInspection/mapSiteInspection";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { Grid, IconButton, Typography } from "@mui/material";
import { FaFilePdf } from "react-icons/fa";
import { Loader } from "@egovernments/digit-ui-react-components";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";

const SubStep4 = ({ formData, handleSubTabChange, isEmployee, isNocModule = false }) => {
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData?.descriptionOfLand,
    },
  };
  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
  const kmlFile = formData?.documents?.find((doc) => doc?.documentType === "kmlFile");
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const onSubmit = (data) => {
    handleSubTabChange(4, data);
  };

  console.log("formData in substep4", formData, "kmlFile", kmlFile, "documents from store", documents, isEmployee);

  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">GEO Location</h2>
          </div>

          <div className="formInputContainer">
            <div className="columnWrapper custom-upload new-custom-uploader">
              <InputWrapper
                label="Latitude"
                control={control}
                placeholder="Enter Latitude"
                name="descriptionOfLand.latitude"
                type="textInput"
                mandatory
                defaultValue={formData?.descriptionOfLand?.latitude}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
                maxLength={10}
                disabled={formData?.descriptionOfLand?.latitude}
              />

              {/* <FileUploader
                                label={t("Upload KML File Option")}
                                control={control}
                                name="kmlFile"
                                validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                required
                                isMandatory
                                tab={1}
                                maxFiles={1}
                            />  */}
              {isEmployee ? (
                <KmlFileUploader
                  name={"kmlFile"}
                  label={"KML File"}
                  isMandatory
                  validationMsg={"(.kml file only and Max file Size 10 MB)"}
                  required
                  tab={1}
                  showError={showError}
                  // control={control}
                  maxFiles={1}
                />
              ) : (
                <React.Fragment>
                  {kmlFile && (
                    <div className="download-kml" style={{ display: "flex", alignItems: "center", gap: "280px" }}>
                      <strong>KML File:</strong>
                      <IconButton size="large" color="info" onClick={() => getDocumentByFileStoreId(kmlFile?.fileStoreId, setLoading)}>
                        {loading ? (
                          <div style={{ width: "14px", height: "14px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Loader />
                          </div>
                        ) : (
                          <TravelExploreOutlinedIcon color="primary" sx={{ fontSize: "14px" }} />
                        )}
                      </IconButton>
                    </div>
                  )}
                  <Grid item xs={4} style={{ display: "flex" }}>
                    <Typography variant="body2" sx={{ color: "#555", marginLeft: "10px" }}>
                      <MapSiteInspection formData={formData} />
                    </Typography>
                  </Grid>
                </React.Fragment>
              )}
            </div>
            <div className="columnWrapper custom-upload new-custom-uploader">
              <InputWrapper
                label="Longitude"
                control={control}
                placeholder="Enter Longitude"
                name="descriptionOfLand.longitude"
                type="textInput"
                mandatory
                defaultValue={formData?.descriptionOfLand?.longitude}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
                maxLength={10}
                disabled={formData?.descriptionOfLand?.longitude}
              />
            </div>
            <br />
          </div>
        </div>
        {!isEmployee && !isNocModule && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(2)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default SubStep4;
